import React, { PureComponent, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import { Card, CardBody, Row, Col } from 'reactstrap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';

import MatAppBar from '../../../shared/components/building_filters/UnitsSearchAppBar';

import Button from '@material-ui/core/Button';
import ColumnsIcon from 'mdi-react/ViewColumnIcon';

import LinearLoading from '../../../shared/components/LinearLoading';
import StickyScrollbar from '../../../shared/components/StickyScrollbar';
import AddCollectionButton from '../../../shared/components/collections/AddCollectionButton';

import SegmentSelector from './SegmentSelector';
import UnitStageFilter from '../../../shared/components/unit_filters/UnitStageFilter';

import { isMobile } from "react-device-detect";

import { Tooltip } from '@material-ui/core';
import moment from "moment";
import { _buildingIDs, _axiosCall } from '../../../shared/helpers/apicalls';
import {
	_capitalizeText,
	_formatNumber,
	_formatDimension,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
	buildingFL,
	propertyFL,
	SalesProgress,
	_isEqual,
	_tranformTagsQuery,
	syncURLFilters,
	syncURLSearch,
	setURLFromState,
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage,
	syncStageFilters,
	syncGenericFilter,
	_objectEqual,
	getCohortQuery,
	getHouseCohortQuery,
	_validUnitSources,
	CurrentStatus,
	HouseCurrentStatus,
	_replaceAbbreviations,
	_formatBed,
	propertyExportFL,
	propertyExportFLRestricted,
	houseExportFL,
} from "../../../shared/helpers/utils";

import {
	_unitFilters,
	_unitStageFilter,
	_buildingStageFilter,
	_houseAdminFilters,
} from "../../../shared/helpers/filters";

import { _hasPermission	} from "../../../shared/helpers/access";
import queryString from "query-string";

// Reuse from PropertySearch
import MatTableHead from '../../PropertySearch/components/MatTableHead';
import ColumnSelector from '../../PropertySearch/components/ColumnSelector';

const buildingUrl = process.env.API_ROOT + '/query/';

const subFilterKey = 'subFilters';
const unitStagesKey = 'unitStages';
const buildingStagesKey = 'buildingStages';
const columnsKey = 'visibleColumns';


// --- Segment Configurations ---
const SEGMENT_CONFIGS = {
	condos: {
		index: 'we3-properties',
		fieldList: propertyFL,
		defaultSort: 'last_listed_sale_price_all',
		defaultOrder: 'desc',
		defaultSubFilter: { current_status: ["available"], property_type: ["residential"] },
		lsPrefix: 'IU_condos_',
		hasBuildingStages: true,
		hasUnitStages: true,
		defaultBuildingStages: ['sponsor'],
		defaultUnitStages: ['all'],
		needsBuildingMerge: false,
		exportFL: propertyExportFL,
		exportName: 'Inventory Search',
	},
	houses: {
		index: 'we3-properties',
		fieldList: propertyFL,
		defaultSort: 'last_listed_sale_date_all',
		defaultOrder: 'desc',
		defaultSubFilter: {},
		lsPrefix: 'IU_houses_',
		hasBuildingStages: false,
		hasUnitStages: false,
		defaultBuildingStages: [],
		defaultUnitStages: [],
		needsBuildingMerge: true,
		exportFL: houseExportFL,
		exportName: 'House Search',
	},
};

// --- Column Definitions ---
const condoColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'current_status', label: 'Status', default: true, group: 'general' },
	{ id: 'bedrooms', label: 'Bed', default: true, group: 'general' },
	{ id: 'baths', label: 'Bath', default: true, group: 'general' },
	{ id: 'last_listed_sale_price_all', label: 'Price', default: true, group: 'financial' },
	{ id: 'last_listed_sale_ppsf_all', label: 'PPSF', default: true, group: 'financial' },
	{ id: 'sq_ft', label: 'SqFt', default: true, group: 'general' },
	{ id: 'last_listed_sale_date_all', label: 'Listed', default: true, group: 'financial' },
	{ id: 'last_sold_price', label: 'Sold Price', default: false, group: 'financial' },
	{ id: 'last_sold_date', label: 'Sold Date', default: false, group: 'financial' },
	{ id: 'property_type', label: 'Type', default: false, group: 'general' },
	{ id: 'floor', label: 'Floor', default: false, group: 'general' },
	{ id: 'ownership_type', label: 'Ownership', default: false, group: 'general' },
];

const houseColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'current_status', label: 'Status', default: true, group: 'general' },
	{ id: 'sq_ft', label: 'SqFt', default: true, group: 'general' },
	{ id: 'bedrooms', label: 'Bed', default: true, group: 'general' },
	{ id: 'baths', label: 'Bath', default: true, group: 'general' },
	{ id: 'last_listed_sale_price_all', label: 'Price', default: true, group: 'financial' },
	{ id: 'last_listed_sale_ppsf_all', label: 'PPSF', default: true, group: 'financial' },
	{ id: 'last_listed_sale_date_all', label: 'Listed', default: true, group: 'financial' },
	{ id: 'last_sold_price', label: 'Sold Price', default: true, group: 'financial' },
	{ id: 'div(last_sold_price, sq_ft)', label: 'Sold PPSF', default: true, group: 'financial', disableSort: true },
	{ id: 'last_sold_date', label: 'Sold Date', default: false, group: 'financial' },
	{ id: 'year_built', label: 'Year Built', default: true, group: 'building' },
	{ id: 'lot_area', label: 'Lot SqFt', default: true, group: 'building' },
	{ id: 'building_frontage', label: 'Bldg Width', default: false, group: 'building' },
	{ id: 'lot_frontage', label: 'Lot Width', default: false, group: 'building' },
];

const SEGMENT_COLUMNS = {
	condos: condoColumns,
	houses: houseColumns,
};

const getDefaultColumns = (segment) => {
	const cols = SEGMENT_COLUMNS[segment] || condoColumns;
	return cols.filter(col => col.default).map(col => col.id);
};

const getPropertyFiltersForSegment = (segment) => {
	if (segment === 'condos') {
		return _unitFilters.filter(filter => !filter.filter_type);
	}
	return _houseAdminFilters.filter(filter => !filter.filter_type || filter.filter_type !== 'building');
};

const getBuildingFiltersForSegment = (segment) => {
	if (segment === 'condos') {
		return _unitFilters.filter(filter => filter.filter_type && filter.filter_type === 'building');
	}
	return _houseAdminFilters.filter(filter => filter.filter_type && filter.filter_type === 'building');
};

const getAllFiltersForSegment = (segment) => {
	if (segment === 'condos') {
		return _unitFilters;
	}
	return _houseAdminFilters;
};


class InventoryMatTable extends PureComponent {
	tableWrapRef = React.createRef();


  _getSegment = () => this.props.segment || 'condos';

  _getConfig = () => SEGMENT_CONFIGS[this._getSegment()] || SEGMENT_CONFIGS['condos'];

  _getActiveColumns = () => SEGMENT_COLUMNS[this._getSegment()] || condoColumns;

  _getPropertyFilters = () => getPropertyFiltersForSegment(this._getSegment());

  _getBuildingFilters = () => getBuildingFiltersForSegment(this._getSegment());

  _getAllFilters = () => getAllFiltersForSegment(this._getSegment());

  state = (() => {
	const segment = this.props.segment || 'condos';
	const config = SEGMENT_CONFIGS[segment] || SEGMENT_CONFIGS['condos'];
	const lsPre = config.lsPrefix;
	const allFilters = getAllFiltersForSegment(segment);

	const params = queryString.parse(this.props.location ? this.props.location.search : '');
	let initialBuildingStages = config.defaultBuildingStages;
	if (params.building_stage) {
		initialBuildingStages = params.building_stage.split(',');
	}

	return {
		order: syncGenericFilter('order', lsPre, 'order', config.defaultOrder),
		orderBy: syncGenericFilter('order_by', lsPre, 'orderBy', config.defaultSort),
		selected: new Map([]),
		page: 0,
		rowsPerPage: 50,
		buildingsFetchInProgress: false,
		clearInput: false,
		end: 30,
		filterBorough: "all_boroughs",
		futureInventoryData: false,
		inventoryData: false,
		originalData: false,
		ovelayMinHeight: false,
		reactTableFiltered: [],
		showCounts: {desktop: 3, tablet: 2, mobile: 1},
		start: 0,
		stats: {},
		subFilters: syncURLFilters(this.props, allFilters, subFilterKey, lsPre, config.defaultSubFilter),
		tableData: false,
		totalCount: 0,
		searchText: syncURLSearch(this.props, 'searchText'),
		facetData: null,
		selectedUnits: {},
		buildingStages: config.hasBuildingStages
			? syncStageFilters(this.props, _buildingStageFilter, buildingStagesKey, lsPre, initialBuildingStages)
			: [],
		unitStages: config.hasUnitStages
			? syncStageFilters(this.props, _unitStageFilter, unitStagesKey, lsPre, config.defaultUnitStages)
			: [],
		visibleColumns: (() => { try { return JSON.parse(getLocalStorage(lsPre, columnsKey) || 'null') || getDefaultColumns(segment); } catch(e) { return getDefaultColumns(segment); } })(),
		columnSelectorOpen: false,
	};
  })();

  // Condos base query
  defaultQ = `((offering_verified_status:active AND source_organizations:NYAG AND offering_baths:[1 TO *] AND offering_price:* AND -offering_file_number:"" AND -address_2_normalized:"") OR (current_status:(active "in contract")) OR ((verification_source:(${_validUnitSources}) OR ownership_type:co*cop) AND -address_2_normalized:"") OR building_class:R3)`;

  defaultBuidingQ = getCohortQuery(this.props.user);
  autocompleteFQ = this.defaultBuidingQ;

  q = '';
  fq = [];
  sort = '';

  componentDidMount() {
	this._fetchData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
	// If segment changed via props, reset everything
	if (prevProps.segment !== this.props.segment) {
		const config = SEGMENT_CONFIGS[this.props.segment] || SEGMENT_CONFIGS['condos'];
		const lsPre = config.lsPrefix;
		const allFilters = getAllFiltersForSegment(this.props.segment);
		this.setState({
			subFilters: syncURLFilters(this.props, allFilters, subFilterKey, lsPre, config.defaultSubFilter),
			buildingStages: config.hasBuildingStages ? config.defaultBuildingStages : [],
			unitStages: config.hasUnitStages ? config.defaultUnitStages : [],
			orderBy: config.defaultSort,
			order: config.defaultOrder,
			page: 0,
			start: 0,
			tableData: false,
			searchText: '',
			visibleColumns: (() => { try { return JSON.parse(getLocalStorage(lsPre, columnsKey) || 'null') || getDefaultColumns(this.props.segment); } catch(e) { return getDefaultColumns(this.props.segment); } })(),
			selectedUnits: {},
		}, () => {
			this._fetchData();
		});
		return;
	}

	let searchTagsChange = !_isEqual(prevProps.searchTags, this.props.searchTags);
	let buildingStageChange = !_isEqual(prevState.buildingStages, this.state.buildingStages);
	let unitStageChange = !_isEqual(prevState.unitStages, this.state.unitStages);

	const allFilters = this._getAllFilters();
	let subFilterChanged = allFilters.filter(item => {
		return (
			Array.isArray(item.search_key) ?
				item.search_key.filter(key => this.state.subFilters[key] !== prevState.subFilters[key]).length > 0
			:
				this.state.subFilters[item.search_key] !== prevState.subFilters[item.search_key]
		);
	}).length > 0;

	if (
		this.state.filterBorough !== prevState.filterBorough ||
		this.state.searchText !== prevState.searchText ||
		this.state.orderBy !== prevState.orderBy ||
		this.state.order !== prevState.order ||
		this.state.page !== prevState.page ||
		this.state.rowsPerPage !== prevState.rowsPerPage ||
		searchTagsChange ||
		subFilterChanged ||
		buildingStageChange ||
		unitStageChange
	) {
		const resetPage = this.state.page === prevState.page;
		this.defaultBuidingQ = getCohortQuery(this.props.user);
		this._fetchData(resetPage);
	}
  }

  handleRequestSort = (event, property) => {
	const orderBy = property;
	let order = 'desc';
	if (this.state.orderBy === property && this.state.order === 'desc') { order = 'asc'; }
	this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event, checked) => {
	if (checked) {
		const { tableData } = this.state;
		const newSelected = new Map();
		tableData.map(n => newSelected.set(n.id, true));
		this.setState({ selected: newSelected });
		return;
	}
	this.setState({ selected: new Map([]) });
  };

  handleClick = (event, id) => {
	event.stopPropagation();
	const { selected } = this.state;
	const newSelected = new Map(selected);
	const value = newSelected.get(id);
	newSelected.set(id, !value);
	this.setState({ selected: newSelected });
  };

  handleBuildingClick = (event, building) => {
	event.preventDefault();
	event.stopPropagation();
	const segment = this._getSegment();
	if (segment === 'condos') {
		const buildingURL = _getBuildingURL(building, 'building_slugs') + '/' + _nameToUrl(building.address_2_normalized ? building.address_2_normalized : "property");
		this.props.history.push(buildingURL);
	} else {
		const buildingURL = _getBuildingURL(building);
		window.open(buildingURL);
	}
  };

  handleChangePage = (event, page) => {
	this.setState({ page: page, start: page * this.state.rowsPerPage });
  };

  handleChangeRowsPerPage = (event) => {
	this.setState({ rowsPerPage: parseInt(event.target.value), page: 0, start: 0 });
  };

  isSelected = (id) => {
	const { selected } = this.state;
	return !!selected.get(id);
  };

  // --- Main fetch dispatcher ---
  _fetchData = (resetPage = true) => {
	if (!this.state.buildingsFetchInProgress) {
		this.setState({ buildingsFetchInProgress: true });
	}
	const segment = this._getSegment();
	if (segment === 'houses') {
		this._fetchHouses(resetPage);
	} else {
		this._fetchCondoUnits(resetPage);
	}
  }

  // --- Condos segment: query we3-properties with building join ---
  _fetchCondoUnits = async (resetPage) => {
	const { user } = this.props;
	const config = this._getConfig();
	const propertyFilters = this._getPropertyFilters();
	const buildingFilters = this._getBuildingFilters();
	const { orderBy, order, unitStages, buildingStages } = this.state;
	const { searchTags } = this.props;

	this.q = this.defaultQ;

	let locQuery = _tranformTagsQuery(searchTags, 'building');
	if (locQuery) {
		this.q += this.q.length > 0 ? " AND " : "";
		this.q += `${locQuery}`;
	}

	this.fq = [
		`-offering_verified_status:stalled`,
		"deleted:false",
		`-offering_unit_abandoned:true`,
		`building_class:R3 OR address_2_normalized:?*`,
	];

	// --- Process property-level filters ---
	this._processFilters(propertyFilters, 'q');

	// --- Process price/date filters for property level ---
	this._processPriceDateFilters(propertyFilters, 'q');

	// --- Unit stage filter ---
	if (unitStages && unitStages.length > 0 && unitStages.indexOf("all") < 0) {
		this.q += this.q.length > 0 ? " AND " : "";
		this.q += `property_status:("${unitStages.join("\" OR \"")}")`;
		this.q += ` AND (source_organizations:(NYAG CDEC ADEC) OR (verification_source:(${_validUnitSources}) OR ownership_type:co*cop) OR current_status:active)`;
	}

	// --- Building-level join query ---
	let defaultBuidingQ = this.defaultBuidingQ;

	if (buildingStages && buildingStages.length > 0 && buildingStages.indexOf("all") < 0) {
		defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
		defaultBuidingQ += `building_status:("${buildingStages.join("\" OR \"")}")`;
	}

	// Process building-level sub-filters
	if (this.state.subFilters && Object.keys(this.state.subFilters).length > 0) {
		Object.keys(this.state.subFilters).map(key => {
			let subFilterVal = this.state.subFilters[key];
			if (subFilterVal && subFilterVal != "") {
				const theFilter = buildingFilters.filter(filter => filter.search_key === key);
				if (theFilter && theFilter[0] && theFilter[0].multi_filter) {
					const qVal = theFilter[0].values.filter(value => subFilterVal.indexOf(value.filter) > -1).map(value => value.search_value);
					if (qVal.length > 0) {
						defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
						defaultBuidingQ += `(${key}:(${qVal.join(" ")}))`;
					}
				} else if (theFilter && theFilter[0] && theFilter[0].autocomplete) {
					const searchKey = theFilter[0].search_key;
					let operator = "AND";
					let searchValue = Array.isArray(subFilterVal) ? subFilterVal : [subFilterVal];
					searchValue = searchValue.map(val => {
						if (val.indexOf("~") >= 0) {
							const parts = val.split("~");
							operator = parts[parts.length - 1];
							return parts[0];
						}
						return val;
					});
					const qVal = searchValue.map(val => `*${val.replace(/[^a-zA-Z0-9]/g, '*')}*`).join(` ${operator} `);
					defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
					defaultBuidingQ += `(${searchKey}:(${qVal}))`;
				} else if (theFilter && theFilter[0]) {
					const qVal = theFilter[0].values && theFilter[0].values.filter(value => value.filter === subFilterVal).length > 0
						? theFilter[0].values.filter(value => value.filter === subFilterVal)[0].search_value
						: null;
					if (qVal !== null) {
						defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
						defaultBuidingQ += `(${key}:${qVal})`;
					}
				}
			}
		});
	}

	// Building-level price/date filters
	this._processPriceDateFilters(buildingFilters, 'building', (bldgQ) => {
		defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
		defaultBuidingQ += `(${bldgQ})`;
	});

	this.autocompleteFQ = defaultBuidingQ;
	this.fq.push(`{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultBuidingQ}`);

	setURLFromState(this.props, this.state);

	// --- Text search ---
	if (this.state.searchText && this.state.searchText.length > 0) {
		const text = this.state.searchText.replace(/ /g, '*').toLowerCase();
		const textCaps = _capitalizeText(this.state.searchText.toLowerCase(), false).replace(/ /g, '*');
		this.q += this.q.length > 0 ? " AND " : "";
		this.q += `(building_name:(*${text}* OR *${textCaps}*) OR display_full_street_address:*${text}* OR neighborhood:*${text}*)`;
	}
	this.q = this.q.length > 0 ? this.q : "*:*";

	// --- Sort ---
	let sort = `${config.defaultSort} ${config.defaultOrder}, display_full_street_address asc, floor asc, address_2_normalized asc`;
	if (orderBy && orderBy.length > 0) {
		if (orderBy === 'address_2_normalized') {
			sort = `floor ${order}, ${orderBy} ${order}`;
		} else if (orderBy === 'offering_price' || orderBy === 'last_listed_sale_price_all') {
			sort = `last_listed_sale_price_all ${order}`;
		} else if (orderBy === 'last_sold_date') {
			sort = `${orderBy} ${order}, last_contract_date ${order}`;
		} else {
			sort = `${orderBy} ${order}`;
		}
	}
	this.sort = sort;

	let axiosData = {
		url: buildingUrl + "we3-properties?cache=30",
		method: "post",
		query: {
			q: this.q,
			fq: this.fq,
			sort: sort,
			fl: config.fieldList,
			rows: this.state.rowsPerPage,
			start: resetPage ? 0 : this.state.start,
			wt: "json",
		}
	};

	let response = await _axiosCall(axiosData)
		.then(res => res)
		.catch(error => { console.log("error: " + error); });

	let formattedData = response && response.docs ? response.docs.slice(0) : [];
	let docs = formattedData.map((doc) => Object.assign({}, doc));

	this.setState({
		buildingsFetchInProgress: false,
		tableData: docs,
		reactTableFiltered: docs,
		totalCount: response ? response.numFound : 0,
		start: resetPage ? 0 : this.state.start,
		page: resetPage ? 0 : this.state.page,
		selectedUnits: {},
	});
  }

  // --- Houses segment: two-step query (we3-properties → we3-buildings merge) ---
  _fetchHouses = async (resetPage) => {
	const { user } = this.props;
	const config = this._getConfig();
	const propertyFilters = this._getPropertyFilters();
	const buildingFilters = this._getBuildingFilters();
	const { orderBy, order } = this.state;
	const { searchTags } = this.props;

	this.q = "";

	let locQuery = _tranformTagsQuery(searchTags);
	if (locQuery) { this.q += locQuery; }

	this.fq = ["deleted:false"];

	// --- Process property-level filters ---
	this._processFilters(propertyFilters, 'q');

	// --- Process price/date filters for property level ---
	this._processPriceDateFilters(propertyFilters, 'q');

	// --- Building-level join query ---
	let defaultBuidingQ = "";

	// Process building-level sub-filters
	if (this.state.subFilters && Object.keys(this.state.subFilters).length > 0) {
		Object.keys(this.state.subFilters).map(key => {
			let subFilterVal = this.state.subFilters[key];
			if (subFilterVal && subFilterVal != "") {
				const theFilter = buildingFilters.filter(filter => filter.search_key === key);
				if (theFilter && theFilter[0] && theFilter[0].multi_filter) {
					const qVal = theFilter[0].values.filter(value => subFilterVal.indexOf(value.filter) > -1).map(value => value.search_value);
					if (qVal.length > 0) {
						defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
						defaultBuidingQ += `(${key}:(${qVal.join(" ")}))`;
					}
				} else if (theFilter && theFilter[0] && theFilter[0].autocomplete) {
					const searchKey = theFilter[0].search_key;
					let operator = "AND";
					let searchValue = Array.isArray(subFilterVal) ? subFilterVal : [subFilterVal];
					searchValue = searchValue.map(val => {
						if (val.indexOf("~") >= 0) { const parts = val.split("~"); operator = parts[parts.length - 1]; return parts[0]; }
						return val;
					});
					const qVal = searchValue.map(val => `*${val.replace(/[^a-zA-Z0-9]/g, '*')}*`).join(` ${operator} `);
					defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
					defaultBuidingQ += `(${searchKey}:(${qVal}))`;
				} else if (theFilter && theFilter[0]) {
					const qVal = theFilter[0].values && theFilter[0].values.filter(value => value.filter === subFilterVal).length > 0
						? theFilter[0].values.filter(value => value.filter === subFilterVal)[0].search_value
						: null;
					if (qVal !== null) {
						defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
						defaultBuidingQ += `(${key}:${qVal})`;
					}
				}
			}
		});
	}

	// Building-level price/date filters
	this._processPriceDateFilters(buildingFilters, 'building', (bldgQ) => {
		defaultBuidingQ += defaultBuidingQ.length > 0 ? " AND " : "";
		defaultBuidingQ += `(${bldgQ})`;
	});

	if (defaultBuidingQ !== "") {
		this.fq.push(`{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultBuidingQ}`);
	}

	setURLFromState(this.props, this.state);

	// --- Text search ---
	if (this.state.searchText && this.state.searchText.length > 0) {
		const text = this.state.searchText.replace(/ /g, '*').toLowerCase();
		const textCaps = _capitalizeText(this.state.searchText.toLowerCase(), false).replace(/ /g, '*');
		this.q += this.q.length > 0 ? " AND " : "";
		this.q += `(name:(*${text}* OR *${textCaps}*) OR display_full_street_address:*${text}* OR neighborhood:*${text}*)`;
	}
	this.q = this.q.length > 0 ? this.q : "*:*";

	// House cohort
	this.fq.push(getHouseCohortQuery(user));

	if (!(user.role && Array.isArray(user.role) && user.role.indexOf('admin') >= 0)) {
		this.fq.push("total_units:[1 TO *]");
	}

	this.sort = `${orderBy} ${order}`;

	// Step 1: Query we3-properties
	let axiosData = {
		url: buildingUrl + "we3-properties?cache=15",
		method: "post",
		query: {
			q: this.q,
			fq: this.fq,
			sort: this.sort,
			fl: config.fieldList,
			wt: "json",
			rows: this.state.rowsPerPage,
			start: resetPage ? 0 : this.state.start,
			"json.facet": { "total_units": "sum(total_units)" }
		}
	};

	let response = await _axiosCall(axiosData)
		.then(res => res)
		.catch(error => { console.log("error: " + error); });

	if (!response || !response.docs || response.docs.length === 0) {
		this.setState({
			buildingsFetchInProgress: false,
			tableData: [],
			reactTableFiltered: [],
			totalCount: response ? response.numFound : 0,
			start: resetPage ? 0 : this.state.start,
			page: resetPage ? 0 : this.state.page,
			selectedUnits: {},
		});
		return;
	}

	// Step 2: Fetch buildings for enrichment
	const buildingIds = response.docs.map(doc => doc.building);
	await this._mergeBuildings(buildingIds, response, resetPage);
  }

  // --- Step 2 of houses: fetch buildings and merge ---
  _mergeBuildings = async (buildingIds, propertiesResponse, resetPage) => {
	const fq = [
		"alternate_keys:(" + buildingIds.join(" ") + ")",
		"deleted:false"
	];

	let axiosData = {
		url: buildingUrl + "we3-buildings?cache=60",
		method: "post",
		query: {
			q: "*:*",
			fq: fq,
			fl: buildingFL,
			wt: "json",
			rows: buildingIds.length,
		}
	};

	let buildingsData = await _axiosCall(axiosData)
		.then(res => res.docs)
		.catch(error => { console.log("error: " + error); return []; });

	// Merge: building data first, property data overwrites
	let docs = propertiesResponse.docs.map(prop => {
		let bldg = buildingsData ? buildingsData.filter(b => b.key === prop.building) : [];
		if (bldg[0]) {
			prop = Object.assign({}, bldg[0], prop);
		}
		return prop;
	});

	this.setState({
		buildingsFetchInProgress: false,
		tableData: docs,
		reactTableFiltered: docs,
		totalCount: propertiesResponse.numFound,
		start: resetPage ? 0 : this.state.start,
		page: resetPage ? 0 : this.state.page,
		facetData: propertiesResponse.facets,
		selectedUnits: {},
	});
  }

  // --- Shared filter processing: multi_filter, autocomplete, single ---
  _processFilters = (filters, target) => {
	if (!this.state.subFilters || Object.keys(this.state.subFilters).length === 0) return;

	Object.keys(this.state.subFilters).map(key => {
		let subFilterVal = this.state.subFilters[key];
		if (subFilterVal && subFilterVal != "") {
			const theFilter = filters.filter(filter => filter.search_key === key);

			if (theFilter && theFilter[0] && theFilter[0].multi_filter) {
				const qVal = theFilter[0].values.filter(value => subFilterVal.indexOf(value.filter) > -1).map(value => value.search_value);
				if (qVal.length > 0) {
					if (theFilter[0].target && theFilter[0].target === "fq" && theFilter[0].join_query) {
						this.fq.push(`${theFilter[0].join_query}(${qVal.join(" OR ")})`);
					} else {
						this.q += this.q.length > 0 ? " AND " : "";
						this.q += `(` + qVal.map(v => `(${key}:${v})`).join(" OR ") + `)`;
					}
				}
			} else if (theFilter && theFilter[0] && theFilter[0].autocomplete) {
				const searchKey = theFilter[0].search_key;
				let operator = "AND";
				let searchValue = Array.isArray(subFilterVal) ? subFilterVal : [subFilterVal];
				searchValue = searchValue.map(val => {
					if (val.indexOf("~") >= 0) { const parts = val.split("~"); operator = parts[parts.length - 1]; return parts[0]; }
					return val;
				});
				const qVal = searchValue.map(val => `*${val.replace(/[^a-zA-Z0-9]/g, '*')}*`).join(` ${operator} `);
				this.q += this.q.length > 0 ? " AND " : "";
				this.q += `(${searchKey}:(${qVal}))`;
			} else if (theFilter && theFilter[0] && theFilter[0].text_filter) {
				let qVal = null;
				if (theFilter[0].search_fields) {
					qVal = subFilterVal.split(" ").map(term => {
						return "(" + theFilter[0].search_fields.map(field => {
							return `${field}:(*${term.toLowerCase()}* *${term.toUpperCase()}* *${_capitalizeText(term)}* *${term}*)`
						}).join(" OR ") + ")"
					}).join(" AND ");
				} else {
					qVal = subFilterVal.split(" ").map(term => {
						return `(${key}:(*${term.toLowerCase()}* *${term.toUpperCase()}* *${_capitalizeText(term)}* *${term}*))`
					}).join(" AND ");
				}
				if (qVal !== null) {
					this.q += this.q.length > 0 ? " AND " : "";
					this.q += `(${qVal})`;
				}
			} else if (theFilter && theFilter[0]) {
				const qVal = theFilter[0].values && theFilter[0].values.length > 0 && theFilter[0].values.filter(value => value.filter === subFilterVal).length > 0
					? theFilter[0].values.filter(value => value.filter === subFilterVal)[0].search_value
					: null;
				if (qVal !== null) {
					if (theFilter[0].target && theFilter[0].target === "fq") {
						this.fq.push(qVal);
					} else {
						this.q += this.q.length > 0 ? " AND " : "";
						this.q += `(${key}:${qVal})`;
					}
				}
			}
		}
	});
  }

  // --- Shared price/date filter processing ---
  _processPriceDateFilters = (filters, mode, callback) => {
	if (!this.state.subFilters || Object.keys(this.state.subFilters).length === 0) return;

	let priceQ = {};
	let replaceKeys = {};

	Object.keys(this.state.subFilters).map(key => {
		let subFilterVal = this.state.subFilters[key];
		if (subFilterVal && subFilterVal != "") {
			// Price filters
			const qArrayFilter = filters.filter(filter => filter.price_filter && Array.isArray(filter.search_key) && filter.search_key.filter(skey => skey === key).length > 0);
			if (qArrayFilter.length > 0) {
				const filterKey = qArrayFilter[0].filter_key;
				if (replaceKeys[filterKey]) {
					replaceKeys[filterKey] = [...replaceKeys[filterKey], ...qArrayFilter[0].search_key];
				} else {
					replaceKeys[filterKey] = [...[], ...qArrayFilter[0].search_key];
				}
				if (priceQ[filterKey]) {
					let regex = new RegExp(`{${key}}`, "g");
					priceQ[filterKey] = priceQ[filterKey].replace(regex, subFilterVal);
				} else {
					priceQ[filterKey] = qArrayFilter[0].search_value.map(search => search.replace(`{${key}}`, subFilterVal)).join(' OR ');
				}
			}

			// Date filters
			const dateArrayFilter = filters.filter(filter => filter.date_filter && Array.isArray(filter.search_key) && filter.search_key.filter(skey => skey === key).length > 0);
			if (dateArrayFilter.length > 0) {
				let dateQ = '';
				let dateReplaceKeys = [];
				dateArrayFilter.forEach(dateF => {
					dateReplaceKeys = [...dateReplaceKeys, ...dateF.search_key];
					if (dateQ) {
						let regex = new RegExp(`{${key}}`, "g");
						dateQ = dateQ.replace(regex, moment(subFilterVal).toISOString());
					} else {
						dateQ = dateF.search_value.map(search => search.replace(`{${key}}`, moment(subFilterVal).toISOString())).join(' OR ');
					}
					if (dateQ) {
						dateReplaceKeys.map(k => {
							let regex = new RegExp(`{${k}}`, "g");
							dateQ = dateQ.replace(regex, '*');
						});
						if (mode === 'building' && callback) {
							callback(dateQ);
						} else {
							this.q += this.q.length > 0 ? " AND " : "";
							this.q += `(${dateQ})`;
						}
					}
				});
			}
		}
	});

	if (priceQ && Object.keys(priceQ).length > 0) {
		Object.keys(priceQ).map(filterKey => {
			const qArrayFilter = filters.filter(filter => filter.filter_key && filter.filter_key == filterKey)[0];
			replaceKeys[filterKey].map(key => {
				let regex = new RegExp(`{${key}}`, "g");
				if (key.indexOf("min") >= 0) {
					priceQ[filterKey] = priceQ[filterKey].replace(regex, '0');
				} else {
					if (key.indexOf("max") >= 0 && qArrayFilter && qArrayFilter.target === "fq") {
						priceQ[filterKey] = priceQ[filterKey].replace(regex, '99999999');
					} else {
						priceQ[filterKey] = priceQ[filterKey].replace(regex, '*');
					}
				}
			});

			if (mode === 'building' && callback) {
				callback(priceQ[filterKey]);
			} else if (qArrayFilter && qArrayFilter.target && qArrayFilter.target === "fq") {
				this.fq.push(priceQ[filterKey]);
			} else {
				this.q += this.q.length > 0 ? " AND " : "";
				this.q += `(${priceQ[filterKey]})`;
			}
		});
	}
  }

  _filterTableByInput = (name, eValue) => {
	this.setState({ searchText: eValue });
  };

  _setSubFilter = (search_key, search_val) => {
	const lsPre = this._getConfig().lsPrefix;
	const subF = Object.assign({}, this.state.subFilters, { [search_key]: search_val });
	this.setState({ subFilters: subF, start: 0, end: this.state.rowsPerPage });
	setLocalStorage(lsPre, subFilterKey, JSON.stringify(subF));
  }

  _setSubFilters = (subFilters) => {
	const lsPre = this._getConfig().lsPrefix;
	const subF = Object.assign({}, this.state.subFilters, subFilters);
	this.setState({ subFilters: subF, start: 0, end: this.state.rowsPerPage });
	setLocalStorage(lsPre, subFilterKey, JSON.stringify(subF));
  }

  _resetSubFilter = () => {
	const config = this._getConfig();
	const lsPre = config.lsPrefix;
	const subF = Object.assign({}, config.defaultSubFilter);
	this.setState({
		subFilters: subF,
		buildingStages: config.hasBuildingStages ? config.defaultBuildingStages : [],
		unitStages: config.hasUnitStages ? config.defaultUnitStages : [],
		start: 0,
		end: this.state.rowsPerPage,
	});
	deleteLocalStorage(lsPre, subFilterKey);
	deleteLocalStorage(lsPre, buildingStagesKey);
	deleteLocalStorage(lsPre, unitStagesKey);
  }

  _resetActive = () => {
	const config = this._getConfig();
	let isDefault = this.props.searchTags.length === 0 &&
		_objectEqual(config.defaultSubFilter, this.state.subFilters);
	if (config.hasBuildingStages) {
		isDefault = isDefault && _objectEqual(config.defaultBuildingStages, this.state.buildingStages);
	}
	if (config.hasUnitStages) {
		isDefault = isDefault && _objectEqual(config.defaultUnitStages, this.state.unitStages);
	}
	return !isDefault;
  }

  _setBuildingStage = (stage) => {
	const lsPre = this._getConfig().lsPrefix;
	const config = this._getConfig();
	let newStages = this.state.buildingStages.slice();
	const index = newStages.indexOf(stage);
	const indexAll = newStages.indexOf('all');

	if (index >= 0) {
		if (stage === "all") { newStages = config.defaultBuildingStages; }
		else { newStages.splice(index, 1); }
	} else {
		if (stage === "all") { newStages = ["all"]; }
		else { if (indexAll >= 0) { newStages.splice(indexAll, 1); } newStages.push(stage); }
	}
	if (newStages.length === 0) newStages = ['all'];

	this.setState({ buildingStages: newStages, start: 0, end: this.state.rowsPerPage });
	setLocalStorage(lsPre, buildingStagesKey, JSON.stringify(newStages));
  }

  _setUnitStage = (stage) => {
	const lsPre = this._getConfig().lsPrefix;
	let newStages = this.state.unitStages.slice();
	const index = newStages.indexOf(stage);
	const indexAll = newStages.indexOf('all');

	if (index >= 0) {
		if (stage === "all") { newStages = ["all"]; }
		else { newStages.splice(index, 1); }
	} else {
		if (stage === "all") { newStages = ["all"]; }
		else { if (indexAll >= 0) { newStages.splice(indexAll, 1); } newStages.push(stage); }
	}
	if (newStages.length === 0) newStages = ['all'];

	this.setState({ unitStages: newStages, start: 0, end: this.state.rowsPerPage });
	setLocalStorage(lsPre, unitStagesKey, JSON.stringify(newStages));
  }

  _selectUnit(property) {
	const { selectedUnits } = this.state;
	const newSelected = Object.assign({}, selectedUnits);
	if (newSelected[property.key]) { delete newSelected[property.key]; }
	else { newSelected[property.key] = property; }
	this.setState({ selectedUnits: Object.assign({}, newSelected) });
  }

  _handleSelectAllClick() {
	const { selectedUnits, reactTableFiltered } = this.state;
	let newSelected = {};
	if (Object.keys(selectedUnits).length < reactTableFiltered.length) {
		reactTableFiltered.forEach(item => { newSelected[item.key] = item; });
	}
	this.setState({ selectedUnits: newSelected });
  }

  _clearSelectedUnits() { this.setState({ selectedUnits: {} }); }

  _setVisibleColumns = (columns) => {
	const lsPre = this._getConfig().lsPrefix;
	this.setState({ visibleColumns: columns });
	setLocalStorage(lsPre, columnsKey, JSON.stringify(columns));
  }

  _toggleColumnSelector = () => {
	this.setState(prevState => ({ columnSelectorOpen: !prevState.columnSelectorOpen }));
  }

  _renderCellValue = (d, columnId) => {
	const segment = this._getSegment();
	switch (columnId) {
		case 'display_full_street_address':
			return null;
		case 'current_status':
			if (segment === 'houses') {
				return <HouseCurrentStatus status={d.current_status} unit={d} />;
			}
			return <CurrentStatus status={d.current_status} unit={d} />;
		case 'bedrooms':
			return <span className="light-text small-text">{d.bedrooms > -1 ? (d.bedrooms === 0 ? 'Studio' : d.bedrooms + ' Bed') : '--'}</span>;
		case 'baths':
			return <span className="light-text small-text">{d.baths > 0 ? d.baths + ' Bath' : '--'}</span>;
		case 'last_listed_sale_price_all':
			return (d.last_listed_sale_price_all && d.last_listed_sale_price_all > 100) ?
				<Fragment>
					<span className="small-text">${_formatNumber(d.last_listed_sale_price_all)}</span>
					{d.last_listed_sale_date_all > 0 && <><br/><span className="light-text small-text" style={{color:"#858AA1"}}>{moment.unix(d.last_listed_sale_date_all).fromNow()}</span></>}
				</Fragment>
				: <span className="light-text small-text">--</span>;
		case 'last_listed_sale_ppsf_all':
			return typeof d["last_listed_sale_ppsf_all"] === 'number' && d["last_listed_sale_ppsf_all"] > 100 ?
				<span className="small-text">${_formatNumber(d["last_listed_sale_ppsf_all"])}</span>
				: <span className="small-text">--</span>;
		case 'sq_ft':
			return <span className="light-text small-text">{d.sq_ft > 1 ? _formatNumber(d.sq_ft) + ' sf' : '--'}</span>;
		case 'last_listed_sale_date_all':
			return d.last_listed_sale_date_all && d.last_listed_sale_date_all > 0 ?
				<span className="light-text small-text">{moment.unix(d.last_listed_sale_date_all).format('MM/DD/YYYY')}</span>
				: <span className="light-text small-text">--</span>;
		case 'last_sold_price':
			return (d.last_sold_price && d.last_sold_price > 100) ?
				<Fragment>
					<span className="small-text">${_formatNumber(d.last_sold_price)}</span>
					{d.last_sold_date > 0 && <><br/><span className="light-text small-text" style={{color:"#858AA1"}}>{moment.unix(d.last_sold_date).fromNow()}</span></>}
				</Fragment>
				: <span className="light-text small-text">--</span>;
		case 'div(last_sold_price, sq_ft)':
			return typeof d["div(last_sold_price, sq_ft)"] === 'number' && d["div(last_sold_price, sq_ft)"] > 100 ?
				<span className="small-text">${_formatNumber(d["div(last_sold_price, sq_ft)"])}</span>
				: <span className="small-text">--</span>;
		case 'last_sold_date':
			return d.last_sold_date && d.last_sold_date > 0 ?
				<span className="light-text small-text">{moment.unix(d.last_sold_date).format('MM/DD/YYYY')}</span>
				: <span className="light-text small-text">--</span>;
		case 'year_built': {
			let current_year = new Date().getFullYear();
			let renovated_year = Math.max(d.year_converted || 0, d.year_altered_1 || 0, d.year_altered_2 || 0);
			return <Fragment>
				<span className="light-text small-text">{d.year_built > 1700 ? d.year_built : '--'} {d.year_built > current_year && '(Proj)'}</span>
				{renovated_year > 1700 && renovated_year > d.year_built &&
					<><br/><span className="light-text small-text" style={{color:"#858AA1"}}>{renovated_year} {renovated_year > current_year ? '(Proj Reno)' : '(Reno)'}</span></>
				}
			</Fragment>;
		}
		case 'lot_area':
			return <span className="light-text small-text">{d.lot_area > 1 ? _formatNumber(d.lot_area) + ' sf' : '--'}</span>;
		case 'building_frontage':
			return <span className="light-text small-text">{d.building_frontage > 1 ? _formatDimension(d.building_frontage) + ' ft' : '--'}</span>;
		case 'lot_frontage':
			return <span className="light-text small-text">{d.lot_frontage > 1 ? _formatDimension(d.lot_frontage) + ' ft' : '--'}</span>;
		case 'property_type':
			return <span className="light-text small-text">{d.property_type ? _capitalizeText(d.property_type) : '--'}</span>;
		case 'floor':
			return <span className="light-text small-text">{d.floor > 0 ? d.floor : '--'}</span>;
		case 'ownership_type':
			return <span className="light-text small-text">{d.ownership_type ? _capitalizeText(d.ownership_type.replace(/-/g, ' ').replace(/\?/g, '-')) : '--'}</span>;
		default:
			return <span className="light-text small-text">--</span>;
	}
  }

  render() {
	const {
		order, orderBy, selected, rowsPerPage, page, tableData, reactTableFiltered, subFilters, totalCount, buildingsFetchInProgress, selectedUnits, visibleColumns, columnSelectorOpen, buildingStages, unitStages
	} = this.state;
	const { user } = this.props;
	const segment = this._getSegment();
	const config = this._getConfig();
	const allFilters = this._getAllFilters();
	const activeColumns = this._getActiveColumns();
	const paginationCount = totalCount;

	const exportFields = segment === 'condos' && user && user.dataExportRestrictions && user.dataExportRestrictions.indexOf('property-fields-restricted') >= 0 ? propertyExportFLRestricted : config.exportFL;

	const filtersForDisplay = (user && user.role && user.role.indexOf('admin') >= 0)
		? allFilters
		: allFilters.filter(item => !item.admin_only);

	const appBar = (
		<Fragment>
			<SegmentSelector activeSegment={segment} />
			<MatAppBar
				handleSearch={this._filterTableByInput}
				numSelected={[...selected].filter(el => el[1]).length}
				handleDeleteSelected={() => {}}
				onRequestSort={this.handleRequestSort}
				subFilters={subFilters}
				searchText={this.state.searchText}
				resetSubFilter={this._resetSubFilter}
				setSubFilter={this._setSubFilter}
				setSubFilters={this._setSubFilters}
				_filters={filtersForDisplay}
				placeHolder={'Building, Neighborhood or Borough'}
				buildingAttributes={[]}
				goToBuilding={true}
				resetActive={this._resetActive()}
				showExport={!!tableData}
				q={this.q}
				fq={this.fq}
				fl={exportFields}
				sort={this.sort}
				totalCount={totalCount}
				core_name={'we3-properties'}
				title={`Export This ${segment === 'houses' ? 'House' : 'Inventory'} Search (CSV)`}
				export_name={config.exportName}
				description={<Fragment><h4><strong>Export this search for your own analysis.</strong></h4></Fragment>}
				{...(config.hasBuildingStages ? {
					buildingStages: buildingStages,
					setBuildingStage: this._setBuildingStage,
					hideBuildingStage: false,
				} : {
					hideBuildingStage: true,
				})}
				{...(config.hasUnitStages ? {
					UnitStageFilter: <UnitStageFilter
						unitStages={unitStages}
						setUnitStage={this._setUnitStage}
					/>,
				} : {})}
				numToShow={7}
				buildingTab={segment === 'condos' ? 'units' : undefined}
			/>
		</Fragment>
	);

	if (!tableData) {
		return (
			<Col md={12} lg={12}>
				<Card>
					<CardBody style={{ padding: 0 }}>
						{appBar}
						<div style={{ padding: "0 10px", clear: "both" }}>
							<LinearLoading />
						</div>
					</CardBody>
				</Card>
			</Col>
		);
	}

	const table = reactTableFiltered;

	return (
		<Col md={12} lg={12}>
			<Card>
				<CardBody style={{ padding: 0 }}>
					{appBar}
					<div style={{ padding: "0 10px", clear: "both" }}>
						{buildingsFetchInProgress ? <LinearLoading /> : <div style={{ height: isMobile ? 0 : 20 }} />}
					</div>
					<div className="material-table__header-info">
						<Row style={{ alignItems: 'center' }}>
							<Col md={6} lg={6}>
								<div className={'count_subheader'}>
									<span className="bold-text">{totalCount > 0 ? _formatNumber(totalCount) : '--'}</span>{` `}{segment === 'houses' ? 'Properties' : 'Units'}
								</div>
							</Col>
							<Col md={6} lg={6} style={{ textAlign: "right", paddingRight: 20, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
								<Button
								className="ps-column-selector-btn"
									onClick={this._toggleColumnSelector}
									size="small"
									variant="outlined"
									startIcon={<ColumnsIcon size={14} />}
									style={{ fontSize: 12, color: '#780F9E', borderColor: '#780F9E' }}
								>
									Columns
								</Button>
							</Col>
						</Row>
					</div>

					<Fragment>
						<AddCollectionButton selectedUnits={selectedUnits} groupType={segment === 'houses' ? "properties" : "units"} clearSelectedUnits={this._clearSelectedUnits.bind(this)} {...this.props} addMultiple />

						<div className="property-search-table">
						<div className="material-table__wrap" ref={this.tableWrapRef}>
							<Table className="material-table">
								<MatTableHead
									numSelected={Object.keys(selectedUnits).length}
									order={order}
									orderBy={orderBy}
									onSelectAllClick={this._handleSelectAllClick.bind(this)}
									onRequestSort={this.handleRequestSort}
									rowCount={tableData.length}
									visibleColumns={visibleColumns}
									allColumns={activeColumns}
								/>
								<TableBody>
									{table.map((d) => {
										const isSelected = this.isSelected(d.id);
										return (
											<TableRow
												className="material-table__row"
												role="checkbox"
												onClick={event => this.handleBuildingClick(event, d)}
												aria-checked={isSelected}
												tabIndex={-1}
												key={d.id}
												selected={isSelected}
											>
												<TableCell className="material-table__cell ps-table__cell--frozen" padding="none">
													<div className="ps-table__frozen-content">
														<div className="ps-table__checkbox">
															<Checkbox checked={selectedUnits[d.key] === undefined ? false : true} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this._selectUnit(d); }} className={`material-table__checkbox ${selectedUnits[d.key] !== undefined && 'material-table__checkbox--checked'}`} />
														</div>
														<div className="ps-table__address">
															{segment === 'condos' ? (
																<Fragment>
																	<span className={"building_name"}>{d.address_2_normalized ? _capitalizeText(d.address_2_normalized) : _capitalizeText(d.display_full_street_address)}</span>
																	<br/><span className="light-text small-text">{_capitalizeText(d.display_full_street_address)}, {d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''} {_capitalizeText(d.borough)}</span>
																</Fragment>
															) : (
																<Fragment>
																	<span className={"building_name"}>{d.name ? _capitalizeText(d.name) : _capitalizeText(d.display_full_street_address)}</span>
																	<br/><span className="light-text small-text">{d.name && _capitalizeText(d.display_full_street_address) + ", "} {d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''} {_capitalizeText(d.borough)}</span>
																	<br/><span className="light-text small-text" style={{color:"#858AA1"}}>{d.total_units > 1 ? "Multi-Family (" + _formatNumber(d.total_units) + ' Units)' : "Single-Family"}</span>
																</Fragment>
															)}
														</div>
													</div>
												</TableCell>
												{visibleColumns.filter(colId => colId !== 'display_full_street_address').map(colId => (
													<TableCell
														key={colId}
														className="material-table__cell ps-table__cell--scroll"
														size="small"
													>
														{this._renderCellValue(d, colId)}
													</TableCell>
												))}
											</TableRow>
										);
									})}
									{table.length === 0 && (
										<TableRow>
											<TableCell colSpan={visibleColumns.length} style={{ textAlign: 'center', padding: 40 }}>
												No data found for your search.
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</div>
						<StickyScrollbar scrollContainerRef={this.tableWrapRef} />
						</div>
						{paginationCount ? <TablePagination
							component="div"
							className="material-table__pagination"
							count={paginationCount}
							rowsPerPage={rowsPerPage}
							page={page}
							backIconButtonProps={{ 'aria-label': 'Previous Page' }}
							nextIconButtonProps={{ 'aria-label': 'Next Page' }}
							onChangePage={this.handleChangePage}
							onChangeRowsPerPage={this.handleChangeRowsPerPage}
							rowsPerPageOptions={[25, 50, 100]}
							dir="ltr"
							SelectProps={{
								inputProps: { 'aria-label': 'rows per page' },
								native: true,
							}}
						/> : null}
					</Fragment>

					<ColumnSelector
						open={columnSelectorOpen}
						onClose={this._toggleColumnSelector}
						visibleColumns={visibleColumns}
						setVisibleColumns={this._setVisibleColumns}
						allColumns={activeColumns}
					/>
				</CardBody>
			</Card>
		</Col>
	);
  }
}

export default connect(state => ({
  user: state.user,
  searchTags: Array.isArray(state.search.searchTags) ? state.search.searchTags.slice() : []
}))(withRouter(InventoryMatTable));
